import React, { useEffect, useState } from "react";
import pClasses from "../Test.module.scss";
import * as h from "../../../helpers";
import { useTranslation } from "react-i18next";
import ButtonsArea from "../../Buttons/ButtonsArea";
import RoundButton from "../../Buttons/RoundButton";
import Title from "../../Title";
import { Slider } from "@mui/material";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../Spinner";
import Alert from "../../Alerts";
import PageMain from "../../Main/PageMain";
import SquareButton from "../../Buttons/SquareButton/SquareButton";

const KEY_AUDIO_VOLUME = "audio_volume";

interface TestExamplesInterface {
  onClick: () => void | null;
  volume: number;
  audioFile: string | null;
  activeTest: string | null;
  setVolume: (newValue: number) => void;
}

export default function TestVolume({
  onClick,
  volume,
  audioFile,
  activeTest,
  setVolume,
}: TestExamplesInterface) {
  const { t } = useTranslation();
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);

  let _content = null as any;
  let _innerContent = <Spinner center />;

  useEffect(() => {
    const audio_volume = localStorage.getItem(KEY_AUDIO_VOLUME);
    if (audio_volume) {
      setVolume(parseInt(audio_volume));
    }
  }, [setVolume]);

  const setVolumeHandler = (event: any, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      setVolume(newValue);
      try {
        localStorage.setItem(KEY_AUDIO_VOLUME, String(newValue));
      } catch (error) {
        console.error("[Error to save volume value]", error);
      }
    }
  };
  if (audioFile && activeTest) {
    _innerContent = (
      <>
        <ButtonsArea vert className={pClasses.AreaBtns}>
          <div>
            <RoundButton
              key={audioFile}
              center
              className={pClasses.BtnPlayHuge}
              disabled={isPlaying}
              faIcon={faPlay}
              huge
              onClick={() =>
                h.playAudioHandler(
                  audioFile,
                  activeTest,
                  volume,
                  isPlaying,
                  setIsPlaying,
                  setHasPlayed
                )
              }
              title={t("global.play_audio_test")}
            />
          </div>
          <Slider
            className={pClasses.VolumeSlider}
            disabled={isPlaying}
            value={volume}
            onChange={setVolumeHandler}
            aria-labelledby="continuous-slider"
          />
          <Title light className={pClasses.VolumeSliderText}>
            {volume &&
              String(volume) + t("global.percent_of_volume_on_platform")}
          </Title>
        </ButtonsArea>
      </>
    );
  }
  _content = (
    <>
      {_innerContent}
      <PageMain center isolate warning>
        <div className={pClasses.testVolume}>
          {t("tests.user_volume_alert")}
        </div>
      </PageMain>
      {/* <ButtonsArea> */}
      <div className={pClasses.ContentFixedButton}>
        <SquareButton
          title={t("global.go_to_examples")}
          text={t("global.go_to_examples")}
          disabled={isPlaying || !hasPlayed}
          onClick={onClick}
        />
      </div>
      {/* </ButtonsArea> */}
    </>
  );
  return <div className={pClasses.VolumeArea}>{_content}</div>;
}
